module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-16x10-desktop@0.5x.034735d7.png";